import React from "react";

const AtIconPause = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      fill="none"
      viewBox="0 0 46 101"
    >
      <path
        fill="#F05223"
        stroke="#fff"
        d="M1 5.5c0-1.193.545-2.338 1.516-3.182C3.487 1.474 4.804 1 6.177 1c1.373 0 2.69.474 3.661 1.318.971.844 1.517 1.99 1.517 3.183v89.998c0 1.194-.546 2.339-1.517 3.183-.97.844-2.288 1.318-3.66 1.318-1.374 0-2.69-.474-3.662-1.318C1.546 97.838 1 96.692 1 95.499V5.501Zm33.645 0c0-1.193.546-2.338 1.517-3.182C37.132 1.474 38.45 1 39.822 1c1.374 0 2.69.474 3.662 1.318.97.844 1.516 1.99 1.516 3.183v89.998c0 1.194-.545 2.339-1.516 3.183-.971.844-2.288 1.318-3.661 1.318-1.373 0-2.69-.474-3.661-1.318-.971-.844-1.517-1.99-1.517-3.183V5.501Z"
      />
    </svg>
  );
};

export default AtIconPause;
